<template>
  <ModifyDatasetForm v-if="$route.params.formName === 'modifyDatasetForm' || $route.params.form_name === 'modifyDatasetForm'" />
  <NewDatasetForm v-else />
</template>
<script>
import ModifyDatasetForm from "./ModifyDatasetForm.vue";
import NewDatasetForm from "./NewDatasetForm.vue";
export default { name: "DatasetForms", components: { ModifyDatasetForm, NewDatasetForm } };
</script>
